module.exports = __webpack_public_path__ + "img/lc-header-filter.71c365f7.svg";